import { render } from "./Recommendation&ComplianceMatrixDialog.vue?vue&type=template&id=6e6f0b34"
import script from "./Recommendation&ComplianceMatrixDialog.vue?vue&type=script&lang=js"
export * from "./Recommendation&ComplianceMatrixDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__